import { useTranslation } from 'react-i18next';
import { ApiError, QueryKeys, SmartAction } from '@connect-x-app/shared-domain-models';
import { updateSmartAction } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateSmartAction = ({ onSuccess }: { onSuccess: () => Promise<void> }) => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  return useMutation<SmartAction, ApiError, SmartAction>({
    mutationFn: updateSmartAction,
    mutationKey: [QueryKeys.SMART_ACTIONS],
    onError: (error: ApiError) => {
      toastError(error.message ?? t('TOAST_ERROR'));
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SMART_ACTIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SMART_ACTION, data.id] });
      toastSuccess(t('TOAST_SUCCESS'));
      onSuccess();
    },
  });
};
